<template>
  <div>
    <a v-if="fileParts.length" @click="showModalOrDownload" style="font-size: 14px"
       class="mail secondary">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 439.9 248.6" style="enable-background:new 0 0 439.9 248.6; height: 18px; fill: #008f86" xml:space="preserve">
        <g>
         <g>
          <path d="M114.8,57.4H57.4v38.2v95.6h19.1v-57.4h38.2c21,0,38.2-17.2,38.2-38.2C153,74.6,135.8,57.4,114.8,57.4z M114.8,114.8H76.5
           V76.5h38.2c11.5,0,19.1,7.6,19.1,19.1S126.2,114.8,114.8,114.8z"/>
           <path d="M382.5,0H57.4C24.9,0,0,24.9,0,57.4v133.9c0,32.5,24.9,57.4,57.4,57.4h325.1c32.5,0,57.4-24.9,57.4-57.4V57.4
           C439.9,24.9,415,0,382.5,0z M420.8,191.2c0,21-17.2,38.2-38.2,38.2H57.4c-21,0-38.2-17.2-38.2-38.2V57.4c0-21,17.2-38.2,38.2-38.2
           h325.1c21,0,38.2,17.2,38.2,38.2V191.2z"/>
           <path d="M229.5,57.4h-57.4v133.9h57.4c21,0,38.2-17.2,38.2-38.2V95.6C267.8,74.6,250.5,57.4,229.5,57.4z M248.6,153
           c0,11.5-7.6,19.1-19.1,19.1h-38.2V76.5h38.2c11.5,0,19.1,7.6,19.1,19.1V153z"/>
           <polygon points="286.9,191.2 306,191.2 306,133.9 363.4,133.9 363.4,114.8 306,114.8 306,76.5 382.5,76.5 382.5,57.4 286.9,57.4
             "/>
         </g>
        </g>
        </svg>
    </a>
    <div style="display: none" class="productData">
      <div style="margin: 20px">

        <div class="preview_head">
          <div class="preview_logo_container">
            <p class="companyName" style="font-size: 19px;" v-if="!preview_logo && form.companyName">
              {{ form.companyName }}</p>
            <div v-else class="preview_logo">
              <img style="max-height: 50px" :src="preview_logo" alt="">
            </div>
          </div>
          <div class="preview_text">
            <div><span>{{ form.adress }}</span><br/> Тел.: {{
                form.phones.map(phone => '+7 ' + phone).join(', ')
              }}; E-mail:
              {{ form.emails.map(email => email.department + ': ' + email.email).join(', ') }}.
            </div>
          </div>
        </div>

        <div v-html="filterHtml.innerHTML"></div>

        <div v-for="(prod, idx) in separatedProducts" :key="idx" style="margin-top: 20px">
          <TableDataToPdf :products="prod" :links="links"/>
          <div v-if="idx !== separatedProducts.length - 1" class="html2pdf__page-break"></div>
        </div>
      </div>
    </div>
    <vue-html2pdf v-if="products"
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="true"
                  :preview-modal="false"
                  :paginate-elements-by-height="1100"
                  :filename="'Подбор модификации Овен ' + currrentFilePart"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="A4"
                  pdf-orientation="portrait"
                  ref="html2Pdf"
    >
      <section v-if="products" slot="pdf-content">
        <div>
          <div v-html="pbfBody"></div>
        </div>
      </section>
    </vue-html2pdf>


    <div class="modal micromodal-slide" id="modal-pdf" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
          <header class="modal__header">
            <h2 class="modal__title" id="modal-1-title">
              Скачать PDF
            </h2>
            <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
          </header>
          <div class="modal__content">
            <div v-if="fileParts">
              <span class="link-part" v-for="(file, file_index) in fileParts" :key="file_index">
                 <div style="margin-right: 5px" class="product-card__button" @click="downloadPdf(file_index)">Скачать (Часть: {{
                     file_index + 1
                   }})</div>
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

import VueHtml2pdf from 'vue-html2pdf'
import TableDataToPdf from "./TableDataToPdf"
import MicroModal from "micromodal"
import goals from '../../goals'

import axios from "axios";

export default {
  name: "PdfGenerator",
  components: {
    TableDataToPdf,
    VueHtml2pdf
  },
  props: ['products', 'filterHtml', 'links', 'preview_logo', 'form', 'userHash'],
  mounted() {

    MicroModal.init({
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: true
    });

    if (!this.userHash) {
      return false
    }

    axios.get('/upl_files/modules/select_backend/mailer/form.php', {
      // axios.get('http://localhost:8081/form.php', {

      params: {
        hash: null
      }
    }).then(response => {
      if (response.data.hash) {
        console.log(response.data)
        // this.hash = response.data.hash
        // this.form.fio = response.data.fio
        // this.logo = response.data.logo
        if (response.data.logo) {
          this.preview_logo = 'https://owen.ru/upl_files/modules/select_backend/mailer/uploads/' + response.data.logo
        }
        this.form.companyName = response.data.company_name
        this.form.webSiteUrl = response.data.site
        this.form.address = response.data.adress

        JSON.parse(response.data.email).forEach((item, i) => {
          this.$set(this.form.emails, i, item)
        })

        this.form.phones = response.data.phone.split(',')
        // this.form.requestCourse = response.data.request_course
        // this.form.owenLinks = response.data.owen_links
      }

    })
  },
  watch: {
    products() {
      this.getHtml(0)
    }
  },

  data() {
    return {
      pbfBody: null,
      separatedProducts: [[]],
      fileParts: [],
      currrentFilePart: 1,
    }
  },
  methods: {

    showModalOrDownload() {

      if (this.fileParts.length === 1) {
        this.downloadPdf(0)
      } else {
        MicroModal.show('modal-pdf')
      }

      goals.getPdf()

    },
    getHtml(fileNumber) {
      this.separatedProducts = [[]]
      this.fileParts = []
      let filterHeight = this.filterHtml.offsetHeight

      let firstPageCount

      if (filterHeight <= 80) {
        firstPageCount = 7
      }

      if (filterHeight >= 80 && filterHeight <= 140) {
        firstPageCount = 6
      }

      if (filterHeight >= 141 && filterHeight < 200) {
        firstPageCount = 4
      }

      if (filterHeight >= 201) {
        firstPageCount = 1
      }

      let size = 80; //размер подмассива

      for (let i = 0; i < Math.ceil(this.products.length / size); i++) {
        this.fileParts[i] = this.products.slice((i * size), (i * size) + size);
      }


      let part = 0
      let currentItem = 0


      this.fileParts[fileNumber].forEach((product, index) => {

        if (index < firstPageCount) {
          this.separatedProducts[part].push(product)
        }

        if (index + 1 === firstPageCount) {
          currentItem = 1
          part++
          this.separatedProducts.push([product])
          return
        }

        if (index + 1 >= firstPageCount && currentItem < 9) {
          this.separatedProducts[part].push(product)
          currentItem++
        }

        if (currentItem === 9) {
          part++
          currentItem = 1
          this.separatedProducts.push([product])

        }

      })

      // this.pbfBody = document.querySelector('.productData').innerHTML

    },

    async downloadPdf(fileNumber) {
      this.currrentFilePart = fileNumber + 1
      await this.getHtml(fileNumber)
      this.pbfBody = await document.querySelector('.productData').innerHTML
      // setTimeout(this.$refs.html2Pdf.generatePdf(), 1000  )
      await this.$refs.html2Pdf.generatePdf()

    },

  }
}
</script>

<style scoped>
.preview_head {
  margin-bottom: 20px;
}

.link-part {
  display: inline-block;
  margin-bottom: 5px;
  cursor: pointer;
}

.preview_text {
  color: #929497;
  font-size: 10px;
}

</style>